module.exports = __webpack_public_path__ + "media/images/alarm-card-797983726919b497018a6d0a465ad2d0.svg";